import request from "./request";
import extend from "lodash/extend";
import forEach from "lodash/forEach";
import keys from "lodash/keys";

// This is an internal module -- use chainedRequest() instead.
class RequestWrapper {

    constructor(dispatcher) {
        this.dispatcher = dispatcher;
    }

    withLoadSpinner(customEvent) {
        const eventName = customEvent || "SHOW_LOAD_SPINNER";
        if (!this.aborted) {
            this.showingLoadSpinner = true;
            this.dispatcher.emit(eventName);
        }
        return this;
    }

    postWithAttachment(endpoint, file, errMsg, extraFields) {
        let req = this.post(endpoint);
        if (!this.aborted) {
            if (!file || !file.name) {
                errMsg = errMsg || "Oops! We couldn't find anything to upload.";
                this.dispatcher.emit("SHOW_FLASH_MESSAGE", { message: errMsg, className: "warning" });
                this.__abort(req);
            } else {
                req.attach(file.name, file);
                if (extraFields && typeof extraFields === "object") {
                    forEach(keys(extraFields), (key) => {
                        const value = extraFields[key];
                        if (value !== undefined && value !== null) {
                            let asString;
                            if (value === true) {
                                asString = "true";
                            } else if (value === false) {
                                asString = "false";
                            } else {
                                asString = String(value);
                            }
                            req.field(key, asString);
                        }
                    });
                }
            }
        }
        return req;
    }
}

// Add the actual request methods (get, post, etc.)
extend(RequestWrapper.prototype, request);
export default RequestWrapper;
